const MIN_FORM_HEIGHT = 460,
  REVIEW_SECTION_MARGIN_TOP = $('.product-images').length ?  -210 : -245,
  MIN_WINDOW_WIDTH = 1126;

export var positionReviews = (containerSelector='.lead-form-container') => {
  if ($(window).outerWidth() < MIN_WINDOW_WIDTH) return;
  let height_diff = $(containerSelector).outerHeight() - MIN_FORM_HEIGHT,
    new_margin_top = REVIEW_SECTION_MARGIN_TOP - height_diff;
  let styleTag = $('#lp-review-styles').length ? $('#lp-review-styles') : $('<style id="lp-review-styles">').appendTo('head');
  if (height_diff > 0) {
    styleTag.text(`@media (min-width: ${MIN_WINDOW_WIDTH}px) { body[class*="_lead_form"] .lp-container .reviews-section { margin-top: ${new_margin_top}px; }}`);
  } else {
    styleTag.remove()
  }
};